import AuthService from './AuthService'
import { startLoading, setErrorAndStopLoading } from './apps/components/Notifications'

let becomeMemberButtons = document.querySelectorAll('.register-button')

window.addEventListener('DOMContentLoaded', () => {
  becomeMemberButtons = document.querySelectorAll('.register-button')

  becomeMemberButtons.forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault()
      try {
        startLoading('authStatus')
        AuthService.redirectSignup()
      } catch (e) {
        setErrorAndStopLoading(e)
      }
    })
  })
})

AuthService.on('ended', e => {
  if (AuthService.isAuthenticated) {
    becomeMemberButtons.forEach(el => {
      el.classList.add('is-hidden')
    })
  } else {
    becomeMemberButtons.forEach(el => {
      el.classList.remove('is-hidden')
    })
  }
})
